import { ExamTimetableContent } from "../../components/app";

export default function ExamTimetable() {
  return <ExamTimetableContent />;
}
